"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IkeObjectCapture = void 0;
var tslib_1 = require("tslib");
var base_1 = require("./base");
var IkeObjectCapture = /** @class */ (function (_super) {
    tslib_1.__extends(IkeObjectCapture, _super);
    function IkeObjectCapture() {
        var _this = _super.call(this) || this;
        _this.className = 'Capture';
        _this.actionName = 'capture';
        _this.cacheKeys['uuid'] = true;
        return _this;
    }
    return IkeObjectCapture;
}(base_1.IkeRestObject));
exports.IkeObjectCapture = IkeObjectCapture;
//# sourceMappingURL=capture.object.js.map